import { useState } from "react";
import { Link, useSearchParams } from "react-router";

import { CertificateCard } from "entities/certificate";
import { ProviderItem } from "entities/provider";
import { Avatar } from "entities/provider/ui/avatar";
import { GenerateCertificateModal } from "features/generate-certificate";
import { Footer } from "pages/ui/footer";
import { Header } from "pages/ui/header";
import { useGetUserQuery } from "shared/api/get-user-query";
import { useHolderCommitment } from "shared/providers/holder-commitment-guard";
import { Breadcrumbs } from "shared/ui/breadcrumbs";
import { Button } from "shared/ui/button";
import { Icon } from "shared/ui/icon";

export const Twitter = () => {
  const [searchParams] = useSearchParams();
  const redirect = Boolean(searchParams.get("redirect"));
  const [isModalOpen, setIsModalOpen] = useState(redirect);
  const userQuery = useGetUserQuery();

  const { holderCommitment, encryptionPubKey, from } = useHolderCommitment();

  return (
    <>
      <div className="flex grow flex-col px-28 pt-[18px]">
        <Header buttonClassName="border border-athensGray" />
        <Breadcrumbs className="mt-[50px]">
          <Breadcrumbs.Item>
            <Link
              className="text-fiord hover:text-fiord/50 focus:text-fiord/50 flex items-center gap-x-2 font-light transition-colors outline-none"
              to="/"
            >
              <Icon name="app" /> Apps
            </Link>
          </Breadcrumbs.Item>
          <Breadcrumbs.Item isActive>X.com (Twitter)</Breadcrumbs.Item>
        </Breadcrumbs>

        <hr className="text-athensGray mt-2.5" />

        <div className="mt-8 flex items-center justify-between">
          <ProviderItem provider="twitter" />
          {userQuery.data ? (
            <Button
              className="py-2.5 text-sm font-semibold"
              onClick={() => setIsModalOpen(true)}
            >
              Generate certificate
            </Button>
          ) : (
            <Button
              as={Link}
              className="py-2.5 text-sm font-semibold"
              to={import.meta.env.VITE_AUTH_URL}
            >
              Connect Account
            </Button>
          )}
        </div>

        <div className="my-8 flex items-start gap-x-8">
          <div className="basis-[93%] pr-28">
            <hr className="text-athensGray" />
            <h2 className="mt-6 text-lg leading-7 font-semibold">
              About the Certificate
            </h2>

            <p className="text-fiord mt-3 font-light">
              Twitter zkCertificate issued on Galactica blockchain allows you to
              verify and showcase your valuable social metrics while preserving
              your anonymity. This allows DApps to tailor experiences,
              facilitate targeted services, and enhance user verification
              processes.
            </p>
            <div className="text-oxfordBlue mt-8 rounded-lg bg-[#F9FAFB] p-4">
              The process to issue your Certificate is swift: authenticate, let
              our platform generate your secret file, and then upload it to
              Galactica to complete verification.
            </div>

            {/* // background: linear-gradient(45deg, #5D5D5D 0%, #1B1B1B 100%); */}
            <div className="mt-8 flex gap-x-5">
              <CertificateCard
                avatar={<Avatar onlyImage provider="twitter" />}
                className="h-[186px] max-w-[350px] basis-1/2 bg-black bg-gradient-to-tr from-[#5D5D5D] to-[#1B1B1B]"
                issueDate="02/24"
                title="X.com zkCertificate"
              />
              {/* background: linear-gradient(45deg, #9DD7F5 0%, #47ACDF 100%);
               */}
              <CertificateCard
                avatar={<Avatar onlyImage provider="twitter" />}
                className="h-[186px] max-w-[350px] basis-1/2 bg-black bg-gradient-to-tr from-[#9DD7F5] to-[#47ACDF]"
                issueDate="02/23"
                title="Twitter zkCertificate"
              />
            </div>

            <h3 className="mt-8 leading-6 font-medium">Privacy</h3>

            <p className="text-fiord mt-4 leading-6 font-medium">
              Your data privacy is paramount. The zkCertificate will be stored
              on a blockchain in the form of Merkle tree that ensures your
              Twitter information remains encrypted and undisclosed. You decide
              if and when to disclose any part of your verified identity. Secure
              your digital presence and embrace true privacy.
            </p>
          </div>

          {/* INFO */}
          <div className="border-athensGray rounded-[10px] border px-6 py-5">
            <h3 className="leading-6">Twitter zkCertificate</h3>
            <p className="text-fiord mt-3 font-light">
              The following fields will be fetched to verify your account
              attributes:
            </p>
            <br />
            <ul className="text-fiord flex list-disc flex-col pl-4 font-light">
              <li>Account creation date and it's age</li>
              <li>Location</li>
              <li>Is verified or not</li>
              <li>Followers count</li>
              <li>Friends count</li>
              <li>Likes count</li>
              <li>Posts count</li>
            </ul>
          </div>
        </div>

        <Footer className="mt-auto" />
      </div>
      {isModalOpen && userQuery.data && (
        <GenerateCertificateModal
          encryptionPubKey={encryptionPubKey}
          from={from}
          holderCommitment={holderCommitment}
          onClose={setIsModalOpen}
        />
      )}
    </>
  );
};
